import { useSelector } from "react-redux";

const useWriteAccessConfig = () => {
    let readOnly = useSelector(val=>(val.auth.config.moduleWriteAccess))
    return readOnly;
}

export {useWriteAccessConfig}